module.exports = __webpack_public_path__ + "img/icon_svea.0f44c242.jpeg";